import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salestag',
  templateUrl: './salestag.component.html',
  styleUrls: ['./salestag.component.css']
})
export class SalestagComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
